<template>
<card size="small" :state="state" scroll-on-show="true" v-show="message.length">
    <template slot="body">
        <div class="flex ai-c">
            <strong class="badge danger" v-if="state === 'bad'"><i class="material-icons">priority_high</i></strong>

            <span class="ml-2">{{ message }}</span>
        </div>
    </template>
</card>
</template>

<script>
export default {
    name: "message-card",

    props: {
        message: String,
        state: String
    }
}
</script>



// WEBPACK FOOTER //
// src/components/MessageCard.vue